import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
/* empty css                             */
const HighlightPrefferedStore = ({ children, title }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "stores-v2-highlight-preferred-store" }, title ? /* @__PURE__ */ React.createElement(Heading, { component: "h5", variant: "subheading1" }, title) : null, children);
};
export {
  HighlightPrefferedStore as default
};
//# sourceMappingURL=HighlightPreferredStore.js.map
